<template>
  <v-container
    fluid
  >
    <v-text-field
      class="ma-2"
      flat
      hide-details
      clearable
      label="Search"
      prepend-inner-icon="mdi-feature-search-outline"
      solo
      v-model="search"
    ></v-text-field>

    <v-card
      class="mx-auto"
    >
      <v-list-item v-for="tag in tags" :key="tag"
          :to="{ name: 'tag', params: { tag: tag } }">
        <v-list-item-content>
          <v-list-item-title>{{ tag }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

const filterTags = (needle) => (tag) => (
  tag.toLowerCase().indexOf(needle) !== -1
)

export default {
  name: 'HomeTags',

  components: {
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters(['allTags']),
    tags () {
      if (this.search) {
        const needle = this.search.toLowerCase()
        return this.allTags.filter(filterTags(needle))
      }
      return this.allTags
    }
  }
}
</script>
